var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.stacked
        ? "chat-widget-actions-stacked"
        : "chat-widget-actions",
    },
    _vm._l(_vm.buttons, function (btn) {
      return _c(
        "button",
        {
          key: btn.action,
          staticClass: "btn btn-sm",
          class: _vm.buttonClass(btn),
          attrs: { title: btn.tooltip || "", disabled: _vm.disabled },
          on: {
            click: function ($event) {
              return _vm.$emit("action", btn.action)
            },
          },
        },
        [
          btn.iconOnly && btn.iconClass
            ? _c("i", { class: btn.iconClass })
            : [
                btn.iconClass
                  ? _c("i", { staticClass: "mr-1", class: btn.iconClass })
                  : _vm._e(),
                _vm._v("\n      " + _vm._s(btn.label) + "\n    "),
              ],
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }